import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

/**
 * A filter which removes undefined and null.
 *
 * ```ts
 * this.store.select(this.selector.getValueOrUndefined()).pipe(ignoreNil())
 * this.store.select(this.selector.getValueOrNull()).pipe(ignoreNil())
 * ```
 *
 * @return An Observable that only emits defined and non-null values.
 */
export const ignoreNil =
	() =>
	<T>(source: Observable<T>) =>
		source.pipe(filter((input): input is NonNullable<T> => input !== undefined && input !== null));
